module.exports = __webpack_public_path__ + "img/tool_bg_image_active_dataset.e2d3f2a3.svg";